var _rect, _rect2, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRtl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 127,
    height: 65,
    viewBox: "0 0 127 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 102.017,
    width: 10,
    height: 101,
    rx: 2,
    transform: "rotate(90 102.017 0)",
    fill: "#7EA6FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 107.431,
    width: 19.5536,
    height: 64,
    rx: 2,
    fill: "#4680FF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 49,
    height: 101,
    rx: 2,
    transform: "matrix(8.70217e-08 -1 -1 -2.19564e-08 102.017 64)",
    fill: "#F5F5F5",
    fillOpacity: 0.4,
    stroke: "#A3C0FF",
    strokeDasharray: "1 1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRtl);
export default __webpack_public_path__ + "static/media/rtl.a315a7f28e9d81a3f979136df25a2a9d.svg";
export { ForwardRef as ReactComponent };